import actions from '../actions/index'

const fotelikiExpose = (store) => window._FOTELIKI_ = {...window._FOTELIKI_, store, actions: actions()}
export default fotelikiExpose;

